// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p, h1 {
    margin: 0;
}

.price {
    /*padding: 50px 100px;*/
    text-align: center;
}

.price h1 {
    font-size: 47.78px;
    font-weight: 900 !important;
}

.Enhanced .button-no-bg,
.Enhanced .Enhanced-btn {
    padding: 14px 24px;
}

.price .price-top {
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    gap: 15px;
    margin: 15px 0;
}

.price-top p.active {
    font-weight: bolder;
    color: #262626;
}

.price-top p {
    font-size: 19.2px;
    color: #5c5c5c;
}

@media (max-width: 1500px) {
    .price-top p b {
        font-size: 19.2px;
        color: #000;
        font-weight: 700;
    }

    .price-top p {
        font-size: 19.2px;
        color: #5c5c5c;
        font-weight: 400;
    }

    .switch {
        height: 29px !important;
    }
}

.price-top .save {
    border: none;
    outline: none;
    background: #fae267;
    border-radius: 4px;
    color: #000;
    font-weight: 700;
    font-size: 14px;
    font-weight: bold;
    padding: 4px 12px;
}

.price .price-card .card {
    text-align: start;
    padding: 25px;
    border-radius: 15px;
    height: 100%;
    box-shadow: 0px 1px 15px rgba(152, 152, 152, 0.15);
    border: 2px solid #ffffff;
}

.border-active {
    border: 2px solid #6438b4 !important;
}

.price .price-card .card h4 {
    font-weight: bold;
    font-size: 19.2px;
    color: #5c5c5c;
}

.price .price-card .card .month div {
    display: flex !important;
    align-items: center;
    margin: 20px 0;
}

.price .price-card .card .d-flex {
    align-items: center;
}

.price .price-card .card .Popular {
    background: #e1e1f9;
    border-radius: 20px;
    border: none;
    outline: none;
    color: #6438b4;
    padding: 5px 15px;
    margin: 0 10px;
    font-weight: bold;
    font-size: 14px;
}

.price .price-card .card .month span {
    font-weight: 400;
    font-size: 14px;
    color: #5c5c5c;
    margin-left: 10px;
}

.price .price-card .card .individual {
    font-weight: 400;
    font-size: 14px;
    color: #5c5c5c;
    min-height: 42px;
}

/*WC 07252023 -- For the communication disclaimer*/
.price .price-card .card .communication {
    font-weight: 500;
    font-size: 12px;
    font-style: italic;
    color: #5c5c5c;
    min-height: 36px;
}

.price-content {
    padding: 12px 0;
}

.price-content p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.price-content img {
    width: 30px;
}

.price-line {
    padding: 15px 0 10px 0;
    border-bottom: 1px solid #d9d9d9;
}

.price .price-card .card .admin {
    display: flex;
    align-items: center;
    margin: 14px 0;
    justify-content: space-between;
}

.price .price-card .card .admin div {
    display: flex;
    font-size: 18px;
}

.price .price-card .card .admin div p {
    margin: 0px 10px;
    color: #262626;
    font-size: 16px;
}

.price .price-card .card .admin img {
    width: 20px;
    object-fit: contain;
}

.price .price-card .card .price-content div {
    display: flex;
    gap: 10px;
    margin: 10px 0;
}

.price .price-card .card .price-content div p {
    font-size: 16px;
    color: #262626;
}

.price .price-card .card .price-content .gry-color p {
    color: #5c5c5c;
}

.price .price-card .card .price-btn {
    font-style: normal;
    font-weight: 700 !important;
    font-size: 16px;
    border: 2px solid #6438B4;
    padding: 16px 24px;
    margin-top: 20px;
    border-radius: 5px;
    background-color: transparent;
    color: #6438B4;
}

.price .price-card .border-active.card .btn-bg {
    background: #6438b4;
    color: #fff;
}

label {
    margin-bottom: 0 !important;
}

.price .price-card .card h1 {
    font-size: 57.33px;
}

@media (max-width: 1500px) {
    .price h1 {
        font-size: 47.78px;
        line-height: 140%;
    }

    .price .price-top {
        margin: 20px auto 70px auto;
    }
}

@media (max-width: 1200px) {
    .price .price-card .col-lg-4 {
        margin: 20px 0 !important;
    }
}

@media (max-width: 1500px) {
    .price .price-card .card h4 {
        font-weight: 700;
        font-size: 19.2px;
        line-height: 140%;
    }

    /*.price {*/
    /*    padding: 40px 35px;*/
    /*}*/

    .price .price-card .card h1 {
        font-weight: 900;
        font-size: 57.33px;
        line-height: 140%;
    }

    .price .price-card .card .month span {
        font-weight: 400;
        font-size: 14px;
        line-height: 140%;
    }

    .price .price-card .card .individual {
        font-weight: 400;
        font-size: 15px;
        line-height: 140%;
    }
}

@media (max-width: 1300px) {
    .price .price-card .card h4 {
        font-size: 18px;
    }

    .price .price-card .card h1 {
        font-size: 35px !important;
    }

    .price .price-card .card .individual {
        font-size: 16px;
    }

    .price .price-card .card {
        padding: 17px;
    }

    .price .price-card .card .month span,
    .price .price-card .card .price-content div p,
    .price .price-card .card .admin div {
        font-size: 16px;
    }

    .price .price-card .card .admin div p {
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
    }
}

label {
    margin-bottom: 0;
}

.price h1 {
    margin: 0px 0px 30px 0;
}

@media (max-width: 991px) {
    .price h1 {
        font-size: 40px;
    }
    .price .price-card .col-lg-4:last-child {
        margin-top: 40px !important;
    }
}

@media (max-width: 768px) {
    .price-top p b {
        font-size: 18px;
    }

    .price-top p {
        font-size: 18px;
    }

    .price-top .save {
        padding: 2px 6px;
        font-size: 15px;
    }

    .price .price-top {
        margin: 20px auto 40px auto !important;
    }
}

@media (max-width: 575px) {
    .price .price-card .col-lg-4:nth-child(2) {
        margin-top: 40px !important;
    }
}
@media (max-width: 420px) {
    /*.price {*/
    /*    padding: 40px 10px;*/
    /*}*/

    .price h1 {
        font-size: 42px;
        line-height: 50px;
    }

    .price .price-card {
        margin-top: 20px !important;
    }

    .price .price-top {
        margin: 20px auto 10px auto !important;
    }

    .switch {
        width: 43px !important;
        height: 23px !important;
    }

    .slider:before {
        width: 17px !important;
        height: 17px !important;
        left: 4px !important;
        bottom: 3px !important;
    }
    .switch input:checked +.slider:before {
        left: -4px !important;
    }

    .price-top p b {
        font-size: 16px;
    }

    .price-top p {
        font-size: 16px;
    }

    .price .price-card .card .price-btn {
        padding: 7px 0;
    }
}


.switch {
    position: relative;
    display: inline-block;
    width: 55px;
    height: 29px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #d9d9d9;
    -webkit-transition: 0.4s;

    transform: translate(0px, 0px);
    transition: 0.6s ease transform, 0.6s box-shadow;
}

.slider:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
}

input:checked + .slider {
    background: #6438b4;
}

input:focus + .slider {
    box-shadow: 0 0 1px #50bfe6;
}

input:checked + .slider:before {
    transform: translateX(26px);
}

.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.slider.disabled {
    cursor: default;
}

.cmh {
    min-height: 47px;
}

.text-purple {
    color: #6c2fbb !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/group/pricing-dialog/pricing-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;QACjB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kDAAkD;IAClD,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,kDAAkD;AAClD;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA,WAAW;IACX,0BAA0B;IAC1B,IAAI;;IAEJ;QACI,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI,WAAW;IACX,0BAA0B;IAC1B,IAAI;;IAEJ;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ;;;AAGA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,wBAAwB;;IAExB,8BAA8B;IAC9B,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IAEvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IAGI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["p, h1 {\n    margin: 0;\n}\n\n.price {\n    /*padding: 50px 100px;*/\n    text-align: center;\n}\n\n.price h1 {\n    font-size: 47.78px;\n    font-weight: 900 !important;\n}\n\n.Enhanced .button-no-bg,\n.Enhanced .Enhanced-btn {\n    padding: 14px 24px;\n}\n\n.price .price-top {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    align-items: center;\n    gap: 15px;\n    margin: 15px 0;\n}\n\n.price-top p.active {\n    font-weight: bolder;\n    color: #262626;\n}\n\n.price-top p {\n    font-size: 19.2px;\n    color: #5c5c5c;\n}\n\n@media (max-width: 1500px) {\n    .price-top p b {\n        font-size: 19.2px;\n        color: #000;\n        font-weight: 700;\n    }\n\n    .price-top p {\n        font-size: 19.2px;\n        color: #5c5c5c;\n        font-weight: 400;\n    }\n\n    .switch {\n        height: 29px !important;\n    }\n}\n\n.price-top .save {\n    border: none;\n    outline: none;\n    background: #fae267;\n    border-radius: 4px;\n    color: #000;\n    font-weight: 700;\n    font-size: 14px;\n    font-weight: bold;\n    padding: 4px 12px;\n}\n\n.price .price-card .card {\n    text-align: start;\n    padding: 25px;\n    border-radius: 15px;\n    height: 100%;\n    box-shadow: 0px 1px 15px rgba(152, 152, 152, 0.15);\n    border: 2px solid #ffffff;\n}\n\n.border-active {\n    border: 2px solid #6438b4 !important;\n}\n\n.price .price-card .card h4 {\n    font-weight: bold;\n    font-size: 19.2px;\n    color: #5c5c5c;\n}\n\n.price .price-card .card .month div {\n    display: flex !important;\n    align-items: center;\n    margin: 20px 0;\n}\n\n.price .price-card .card .d-flex {\n    align-items: center;\n}\n\n.price .price-card .card .Popular {\n    background: #e1e1f9;\n    border-radius: 20px;\n    border: none;\n    outline: none;\n    color: #6438b4;\n    padding: 5px 15px;\n    margin: 0 10px;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.price .price-card .card .month span {\n    font-weight: 400;\n    font-size: 14px;\n    color: #5c5c5c;\n    margin-left: 10px;\n}\n\n.price .price-card .card .individual {\n    font-weight: 400;\n    font-size: 14px;\n    color: #5c5c5c;\n    min-height: 42px;\n}\n\n/*WC 07252023 -- For the communication disclaimer*/\n.price .price-card .card .communication {\n    font-weight: 500;\n    font-size: 12px;\n    font-style: italic;\n    color: #5c5c5c;\n    min-height: 36px;\n}\n\n.price-content {\n    padding: 12px 0;\n}\n\n.price-content p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.price-content img {\n    width: 30px;\n}\n\n.price-line {\n    padding: 15px 0 10px 0;\n    border-bottom: 1px solid #d9d9d9;\n}\n\n.price .price-card .card .admin {\n    display: flex;\n    align-items: center;\n    margin: 14px 0;\n    justify-content: space-between;\n}\n\n.price .price-card .card .admin div {\n    display: flex;\n    font-size: 18px;\n}\n\n.price .price-card .card .admin div p {\n    margin: 0px 10px;\n    color: #262626;\n    font-size: 16px;\n}\n\n.price .price-card .card .admin img {\n    width: 20px;\n    object-fit: contain;\n}\n\n.price .price-card .card .price-content div {\n    display: flex;\n    gap: 10px;\n    margin: 10px 0;\n}\n\n.price .price-card .card .price-content div p {\n    font-size: 16px;\n    color: #262626;\n}\n\n.price .price-card .card .price-content .gry-color p {\n    color: #5c5c5c;\n}\n\n.price .price-card .card .price-btn {\n    font-style: normal;\n    font-weight: 700 !important;\n    font-size: 16px;\n    border: 2px solid #6438B4;\n    padding: 16px 24px;\n    margin-top: 20px;\n    border-radius: 5px;\n    background-color: transparent;\n    color: #6438B4;\n}\n\n.price .price-card .border-active.card .btn-bg {\n    background: #6438b4;\n    color: #fff;\n}\n\nlabel {\n    margin-bottom: 0 !important;\n}\n\n.price .price-card .card h1 {\n    font-size: 57.33px;\n}\n\n@media (max-width: 1500px) {\n    .price h1 {\n        font-size: 47.78px;\n        line-height: 140%;\n    }\n\n    .price .price-top {\n        margin: 20px auto 70px auto;\n    }\n}\n\n@media (max-width: 1200px) {\n    .price .price-card .col-lg-4 {\n        margin: 20px 0 !important;\n    }\n}\n\n@media (max-width: 1500px) {\n    .price .price-card .card h4 {\n        font-weight: 700;\n        font-size: 19.2px;\n        line-height: 140%;\n    }\n\n    /*.price {*/\n    /*    padding: 40px 35px;*/\n    /*}*/\n\n    .price .price-card .card h1 {\n        font-weight: 900;\n        font-size: 57.33px;\n        line-height: 140%;\n    }\n\n    .price .price-card .card .month span {\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 140%;\n    }\n\n    .price .price-card .card .individual {\n        font-weight: 400;\n        font-size: 15px;\n        line-height: 140%;\n    }\n}\n\n@media (max-width: 1300px) {\n    .price .price-card .card h4 {\n        font-size: 18px;\n    }\n\n    .price .price-card .card h1 {\n        font-size: 35px !important;\n    }\n\n    .price .price-card .card .individual {\n        font-size: 16px;\n    }\n\n    .price .price-card .card {\n        padding: 17px;\n    }\n\n    .price .price-card .card .month span,\n    .price .price-card .card .price-content div p,\n    .price .price-card .card .admin div {\n        font-size: 16px;\n    }\n\n    .price .price-card .card .admin div p {\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 150%;\n    }\n}\n\nlabel {\n    margin-bottom: 0;\n}\n\n.price h1 {\n    margin: 0px 0px 30px 0;\n}\n\n@media (max-width: 991px) {\n    .price h1 {\n        font-size: 40px;\n    }\n    .price .price-card .col-lg-4:last-child {\n        margin-top: 40px !important;\n    }\n}\n\n@media (max-width: 768px) {\n    .price-top p b {\n        font-size: 18px;\n    }\n\n    .price-top p {\n        font-size: 18px;\n    }\n\n    .price-top .save {\n        padding: 2px 6px;\n        font-size: 15px;\n    }\n\n    .price .price-top {\n        margin: 20px auto 40px auto !important;\n    }\n}\n\n@media (max-width: 575px) {\n    .price .price-card .col-lg-4:nth-child(2) {\n        margin-top: 40px !important;\n    }\n}\n@media (max-width: 420px) {\n    /*.price {*/\n    /*    padding: 40px 10px;*/\n    /*}*/\n\n    .price h1 {\n        font-size: 42px;\n        line-height: 50px;\n    }\n\n    .price .price-card {\n        margin-top: 20px !important;\n    }\n\n    .price .price-top {\n        margin: 20px auto 10px auto !important;\n    }\n\n    .switch {\n        width: 43px !important;\n        height: 23px !important;\n    }\n\n    .slider:before {\n        width: 17px !important;\n        height: 17px !important;\n        left: 4px !important;\n        bottom: 3px !important;\n    }\n    .switch input:checked +.slider:before {\n        left: -4px !important;\n    }\n\n    .price-top p b {\n        font-size: 16px;\n    }\n\n    .price-top p {\n        font-size: 16px;\n    }\n\n    .price .price-card .card .price-btn {\n        padding: 7px 0;\n    }\n}\n\n\n.switch {\n    position: relative;\n    display: inline-block;\n    width: 55px;\n    height: 29px;\n}\n\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #d9d9d9;\n    -webkit-transition: 0.4s;\n\n    transform: translate(0px, 0px);\n    transition: 0.6s ease transform, 0.6s box-shadow;\n}\n\n.slider:before {\n    position: absolute;\n    content: \"\";\n    height: 22px;\n    width: 22px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n}\n\ninput:checked + .slider {\n    background: #6438b4;\n}\n\ninput:focus + .slider {\n    box-shadow: 0 0 1px #50bfe6;\n}\n\ninput:checked + .slider:before {\n    -webkit-transform: translateX(26px);\n    -ms-transform: translateX(26px);\n    transform: translateX(26px);\n}\n\n.slider.round {\n    border-radius: 34px;\n}\n\n.slider.round:before {\n    border-radius: 50%;\n}\n\n.slider.disabled {\n    cursor: default;\n}\n\n.cmh {\n    min-height: 47px;\n}\n\n.text-purple {\n    color: #6c2fbb !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
